"use client";

import React, { useState } from "react";
import { ChevronLeft, ChevronRight, Cpu, Clock, Users, CircleCheck as CheckCircle2, Compass, Sparkles, Layers, Quote, Target, Wrench, Code, Presentation, ArrowRight, ShieldCheck, MapPin, Flame, Laptop, Coins, Trophy, Workflow } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
interface TranslationStrings {
  homeCrumb: string;
  pathwayCrumb: string;
  trackCrumb: string;
  courseCrumb: string;
  courseLabel: string;
  ageBadge: string;
  title: string;
  conceptQuote: string;
  platformLabel: string;
  durationLabel: string;
  groupSizeLabel: string;
  prerequisiteLabel: string;
  prerequisiteVal: string;
  focusTitle: string;
  focusDesc: string;
  ctaConsult: string;
  ctaPathway: string;
  whoIsThisForTitle: string;
  whoIsThisForCopy: string;
  whoIsThisForSubtitle: string;
  timelineTitle: string;
  timelineSubtitle: string;
  methodologyTitle: string;
  methodologySubtitle: string;
  equipmentCardTitle: string;
  equipmentCardSubtitle: string;
  equipmentModel: string;
  equipmentCostLabel: string;
  equipmentCostValue: string;
  equipmentCostNote: string;
  computerRequirementLabel: string;
  computerRequirementVal: string;
  groupModelTitle: string;
  groupModelSubtitle: string;
  groupIdeal: string;
  groupIdealDesc: string;
  groupOptimized: string;
  groupOptimizedDesc: string;
  capstoneTitle: string;
  capstoneSubtitle: string;
  capstoneDesc: string;
  roadmapTitle: string;
  roadmapSubtitle: string;
  currentTag: string;
  nextStepTitle: string;
  nextStepCourse: string;
  nextStepDesc: string;
  nextStepCta: string;
  prevCourse: string;
  nextCourse: string;
  relatedProgramsTitle: string;
  viewProgramDetails: string;
}
const contentData: Record<"vi" | "en", TranslationStrings> = {
  vi: {
    homeCrumb: "Trang chủ",
    pathwayCrumb: "Lộ trình Robotics",
    trackCrumb: "Robotics 7+ tuổi",
    courseCrumb: "HP5 – Thành phố xe tự lái",
    courseLabel: "Khóa học HP5",
    ageBadge: "Từ 7 tuổi",
    title: "Thành phố xe tự lái",
    conceptQuote: "Robot tự hành và lập kế hoạch đường đi.",
    platformLabel: "Nền tảng phần cứng",
    durationLabel: "Thời lượng đào tạo",
    groupSizeLabel: "Quy mô nhóm",
    prerequisiteLabel: "Điều kiện tiên quyết",
    prerequisiteVal: "Hoàn thành HP4",
    focusTitle: "Trọng tâm kiến thức & Kỹ thuật cốt lõi",
    focusDesc: "Trang bị tư duy thuật toán định tuyến, xử lý tín hiệu cảm biến quang sai 5 kênh và điều hướng xe tự hành thông minh trong sa bàn đô thị thực tế.",
    ctaConsult: "ĐĂNG KÝ TƯ VẤN",
    ctaPathway: "XEM TOÀN BỘ LỘ TRÌNH",
    whoIsThisForTitle: "Khóa học này dành cho ai?",
    whoIsThisForCopy: "Dành cho học viên đã hoàn thành HP4. HP5 đưa trẻ vào lập trình robot tự hành bám vạch và lập kế hoạch tuyến đường.",
    whoIsThisForSubtitle: "Chương trình được thiết kế chuẩn xác để xây dựng năng lực giải thuật điều khiển và tự động hóa.",
    timelineTitle: "Lộ trình 12 buổi học (6 giai đoạn chuyên sâu)",
    timelineSubtitle: "Nội dung chuẩn hóa từ các chủ đề kỹ thuật chính thức của khóa HP5:",
    methodologyTitle: "Phương pháp học 4 bước",
    methodologySubtitle: "Quy trình chuẩn hóa phòng lab R&D giúp học viên làm chủ kiến thức vững chắc:",
    equipmentCardTitle: "Thiết bị & Nền tảng phần cứng",
    equipmentCardSubtitle: "Bộ công cụ tiêu chuẩn công nghệ giáo dục hiện đại",
    equipmentModel: "WhalesBot AI Module 1S",
    equipmentCostLabel: "Chi phí thiết bị tham khảo",
    equipmentCostValue: "~6.500.000 VNĐ / bộ",
    equipmentCostNote: "Lưu ý: Đây là chi phí thiết bị tham khảo, không phải học phí.",
    computerRequirementLabel: "Thiết bị học tập bắt buộc",
    computerRequirementVal: "Yêu cầu máy tính xách tay (Laptop)",
    groupModelTitle: "Mô hình học nhóm nhỏ",
    groupModelSubtitle: "Cấu hình phân bổ học viên nhằm đảm bảo trải nghiệm tương tác thực tế tối đa",
    groupIdeal: "2 học sinh / bộ kit (Lý tưởng)",
    groupIdealDesc: "Tối ưu hóa thời lượng chạm tay vào robot, phân chia vai trò lập trình viên và kỹ sư cơ cấu rõ ràng.",
    groupOptimized: "3 học sinh / bộ kit (Tối ưu chi phí)",
    groupOptimizedDesc: "Rèn luyện kỹ năng làm việc nhóm kỹ thuật, giải quyết bài toán phân công và thử nghiệm xoay vòng.",
    capstoneTitle: "Hoạt động thử thách cuối khóa (Capstone Challenge)",
    capstoneSubtitle: "Đánh giá năng lực tự hành và lập kế hoạch điều hướng trên sa bàn",
    capstoneDesc: "Học viên hoàn thành thử thách điều hướng và tuần tra tự hành tổng hợp: tích hợp cảm biến quang sai 5 kênh để bám vạch ổn định, phát hiện và xử lý chính xác các ngã tư, đồng thời vận dụng thuật toán đường đi ngắn nhất để di chuyển qua các điểm định tuyến yêu cầu trong thời gian tối ưu.",
    roadmapTitle: "Vị trí trong lộ trình đào tạo ROBOTO",
    roadmapSubtitle: "Hệ thống 10 chặng nâng cao năng lực robotics liên tục từ cơ bản đến chuyên sâu:",
    currentTag: "Đang học (Hiện tại)",
    nextStepTitle: "Bước tiếp theo của con là gì?",
    nextStepCourse: "HP6 – Robot nhiệm vụ (Mission Robot)",
    nextStepDesc: "Sau khi làm chủ công nghệ xe tự hành HP5, học viên sẽ nâng cấp lên các nhiệm vụ phức hợp quy mô lớn: giải thuật phối hợp đa cảm biến, tay gắp nâng hạ tải trọng và sa bàn thi đấu chuẩn WRO/MakeX.",
    nextStepCta: "XEM HP6 →",
    prevCourse: "← HP4 — Xe robot thông minh",
    nextCourse: "HP6 — Robot nhiệm vụ →",
    relatedProgramsTitle: "Các chương trình đào tạo liên quan",
    viewProgramDetails: "Xem chi tiết chương trình"
  },
  en: {
    homeCrumb: "Home",
    pathwayCrumb: "Robotics Pathway",
    trackCrumb: "Robotics Ages 7+",
    courseCrumb: "HP5 – Autonomous City Car",
    courseLabel: "Course HP5",
    ageBadge: "Ages 7+",
    title: "Autonomous City Car",
    conceptQuote: "Autonomous robotics and intelligent path planning.",
    platformLabel: "Hardware Platform",
    durationLabel: "Course Duration",
    groupSizeLabel: "Class Size",
    prerequisiteLabel: "Prerequisite",
    prerequisiteVal: "Completed HP4",
    focusTitle: "Core Focus & Engineering Concepts",
    focusDesc: "Equip algorithmic routing thinking, 5-channel grayscale optical sensing, and real-world autonomous navigation across urban grid environments.",
    ctaConsult: "BOOK CONSULTATION",
    ctaPathway: "VIEW FULL PATHWAY",
    whoIsThisForTitle: "Who is this course for?",
    whoIsThisForCopy: "For learners who completed HP4. HP5 introduces autonomous line-following robots and route-planning algorithms.",
    whoIsThisForSubtitle: "Structured specifically to cultivate automated control algorithms and routing capabilities.",
    timelineTitle: "12-Session Timeline (6 Focused Stages)",
    timelineSubtitle: "Curriculum systematically arranged from HP5's official technical competencies:",
    methodologyTitle: "4-Step Learning Method",
    methodologySubtitle: "Standardized R&D lab engineering cycle driving independent problem solving:",
    equipmentCardTitle: "Equipment & Hardware Platform",
    equipmentCardSubtitle: "Industry-standard educational robotics ecosystem",
    equipmentModel: "WhalesBot AI Module 1S",
    equipmentCostLabel: "Reference equipment cost",
    equipmentCostValue: "~6,500,000 VNĐ / kit",
    equipmentCostNote: "Note: This is reference equipment cost, not tuition fee.",
    computerRequirementLabel: "Required Study Device",
    computerRequirementVal: "Computer required (Laptop)",
    groupModelTitle: "Small-Group Learning Model",
    groupModelSubtitle: "Calibrated student-to-kit allocation ensuring hands-on engagement and collaboration",
    groupIdeal: "2 students / kit (Ideal)",
    groupIdealDesc: "Maximizes individual physical assembly time, with dedicated programmer and mechanical engineering roles.",
    groupOptimized: "3 students / kit (Cost-optimized)",
    groupOptimizedDesc: "Fosters technical teamwork, rotational task assignment, and collaborative code debugging.",
    capstoneTitle: "Final Capstone Activity",
    capstoneSubtitle: "Comprehensive autonomous navigation and grid routing demonstration",
    capstoneDesc: "Students complete an integrated autonomous patrol and navigation challenge: applying 5-channel grayscale calibration for steady line-tracking, managing intersection decisions, and executing shortest-path algorithms across an urban course under timed conditions.",
    roadmapTitle: "Position in Robotics Pathway",
    roadmapSubtitle: "Track student progression across all 10 modular checkpoints in the academy pathway:",
    currentTag: "Current Stage",
    nextStepTitle: "What's next for your child?",
    nextStepCourse: "HP6 – Mission Robot",
    nextStepDesc: "Having mastered autonomous vehicular navigation in HP5, students advance to high-stakes complex task automation: multi-sensor collaborative choreography, motorized arm manipulation, and competitive arena challenges.",
    nextStepCta: "VIEW HP6 →",
    prevCourse: "← HP4 — Smart Robot Car",
    nextCourse: "HP6 — Mission Robot →",
    relatedProgramsTitle: "Related Academic Programs",
    viewProgramDetails: "View Program Details"
  }
};
const timelineStages = [{
  stage: "01",
  sessionsVi: "Buổi 1 – 2",
  sessionsEn: "Sessions 1 – 2",
  titleVi: "5-Channel Grayscale Sensor & Threshold",
  titleEn: "5-Channel Grayscale Sensor & Threshold",
  topicsVi: "Cảm biến quang sai 5 kênh (5-Channel Grayscale Sensor) và thiết lập ngưỡng nhận diện (Threshold).",
  topicsEn: "5-Channel Grayscale Sensor hardware calibration and reflectance threshold setting."
}, {
  stage: "02",
  sessionsVi: "Buổi 3 – 4",
  sessionsEn: "Sessions 3 – 4",
  titleVi: "Line Following & Error/Deviation",
  titleEn: "Line Following & Error/Deviation",
  topicsVi: "Thuật toán bám vạch (Line Following) và tính toán sai số, độ lệch quỹ đạo (Error/Deviation).",
  topicsEn: "Line Following core routines and error/deviation calculation from track centerline."
}, {
  stage: "03",
  sessionsVi: "Buổi 5 – 6",
  sessionsEn: "Sessions 5 – 6",
  titleVi: "Intuitive P correction & Patrol line",
  titleEn: "Intuitive P correction & Patrol line",
  topicsVi: "Giải thuật hiệu chỉnh P trực quan (Intuitive P correction) và cơ chế bám vạch tuần tra (Patrol line).",
  topicsEn: "Intuitive P proportional correction algorithm and continuous patrol line navigation."
}, {
  stage: "04",
  sessionsVi: "Buổi 7 – 8",
  sessionsEn: "Sessions 7 – 8",
  titleVi: "Intersections & Intersection Handling",
  titleEn: "Intersections & Intersection Handling",
  topicsVi: "Nhận diện giao lộ và xử lý các điểm chuyển hướng rẽ trên ngã tư (Intersections).",
  topicsEn: "Detecting grid intersections, counting cross-junctions, and executing turn decisions."
}, {
  stage: "05",
  sessionsVi: "Buổi 9 – 10",
  sessionsEn: "Sessions 9 – 10",
  titleVi: "Route mapping & Route planning",
  titleEn: "Route mapping & Route planning",
  topicsVi: "Lập bản đồ tuyến đường (Route mapping) và quy hoạch lộ trình di chuyển (Route planning).",
  topicsEn: "Topological route mapping and multi-node path planning across city grids."
}, {
  stage: "06",
  sessionsVi: "Buổi 11 – 12",
  sessionsEn: "Sessions 11 – 12",
  titleVi: "Shortest path & Navigation Integration",
  titleEn: "Shortest path & Navigation Integration",
  topicsVi: "Thuật toán tìm đường đi ngắn nhất (Shortest path) và tối ưu hóa toàn diện xe tự hành.",
  topicsEn: "Shortest path algorithmic routing and full autonomous navigation challenge execution."
}];
const methodologySteps = [{
  step: "1",
  icon: Sparkles,
  titleVi: "Khởi động",
  titleEn: "Warm-up",
  descVi: "Khám phá bài toán thực tế, quan sát mô hình xe tự hành và đặt mục tiêu kỹ thuật cho buổi học.",
  descEn: "Explore real-world challenges, observe autonomous vehicle concepts, and define technical session goals."
}, {
  step: "2",
  icon: Wrench,
  titleVi: "Lắp ráp",
  titleEn: "Assembly",
  descVi: "Xây dựng cơ cấu cơ khí chính xác, bố trí cụm cảm biến quang sai 5 kênh và cân bằng khí động học.",
  descEn: "Assemble precision mechanical linkages, position optical sensor arrays, and balance structural chassis."
}, {
  step: "3",
  icon: Code,
  titleVi: "Lập trình",
  titleEn: "Coding",
  descVi: "Lập trình thuật toán điều khiển phản hồi, tinh chỉnh ngưỡng cảm biến và tối ưu hóa giải thuật đường đi.",
  descEn: "Develop feedback control logic, calibrate sensor thresholds, and optimize path-finding routines."
}, {
  step: "4",
  icon: Presentation,
  titleVi: "Trình bày",
  titleEn: "Presentation",
  descVi: "Thuyết minh giải pháp kỹ thuật, phân tích dữ liệu thử nghiệm và giải thích cơ chế bám line đã đạt được.",
  descEn: "Demonstrate engineering builds, share testing telemetry, and explain line-following navigation principles."
}];
const focusSkills = [{
  vi: "Cảm biến Grayscale 5 kênh",
  en: "5-Channel Grayscale Sensor",
  tag: "Sensor"
}, {
  vi: "Bám vạch (Line following)",
  en: "Line Following Algorithm",
  tag: "Control"
}, {
  vi: "Ngưỡng nhận diện (Threshold)",
  en: "Threshold Calibration",
  tag: "Signal"
}, {
  vi: "Giao lộ & Đếm giao lộ (Intersections)",
  en: "Intersections & Counting",
  tag: "Logic"
}, {
  vi: "Bản đồ tuyến đường (Route mapping)",
  en: "Route Mapping",
  tag: "Mapping"
}, {
  vi: "Quy hoạch đường đi (Route planning)",
  en: "Route Planning",
  tag: "Path"
}, {
  vi: "Tuần tra sa bàn (Patrol line)",
  en: "Patrol Line Routine",
  tag: "Execution"
}, {
  vi: "Độ lệch & Xử lý sai số (Error/Deviation)",
  en: "Error & Deviation Tracking",
  tag: "Math"
}, {
  vi: "Hiệu chỉnh P trực quan (Intuitive P correction)",
  en: "Intuitive P Correction",
  tag: "Algorithm"
}, {
  vi: "Đường đi ngắn nhất (Shortest path)",
  en: "Shortest Path Optimization",
  tag: "Optimization"
}];
const pathwayNodes = [{
  code: "D1",
  nameVi: "Khám phá 1",
  nameEn: "Discovery 1",
  url: "/RoboticsCourseD1Page",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d1.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d1.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d1.png-wvc-sizes"
}, {
  code: "D2",
  nameVi: "Khám phá 2",
  nameEn: "Discovery 2",
  url: "/RoboticsCourseD2Page",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d2.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d2.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d2.png-wvc-sizes"
}, {
  code: "D3",
  nameVi: "Khám phá 3",
  nameEn: "Discovery 3",
  url: "/RoboticsCourseD3Page",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d3.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d3.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d3.png-wvc-sizes"
}, {
  code: "D4",
  nameVi: "Khám phá 4",
  nameEn: "Discovery 4",
  url: "/RoboticsCourseD4Page",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d4.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d4.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_d4.png-wvc-sizes"
}, {
  code: "HP1",
  nameVi: "Cơ bản 1",
  nameEn: "Core 1",
  url: "/RoboticsCourseHP1Page",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp1.webp",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp1.webp-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp1.webp-wvc-sizes"
}, {
  code: "HP2",
  nameVi: "Cơ bản 2",
  nameEn: "Core 2",
  url: "/RoboticsCourseHP2Page",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp2.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp2.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp2.png-wvc-sizes"
}, {
  code: "HP3",
  nameVi: "Nâng cao 3",
  nameEn: "Advanced 3",
  url: "/RoboticsCourseHP3Page",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp3.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp3.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp3.png-wvc-sizes"
}, {
  code: "HP4",
  nameVi: "Xe robot",
  nameEn: "Smart Car",
  url: "/RoboticsCourseHP4Page",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp4.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp4.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp4.png-wvc-sizes"
}, {
  code: "HP5",
  nameVi: "Xe tự lái",
  nameEn: "Auto City",
  url: "/RoboticsCourseHp5Page",
  isCurrent: true,
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp5.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp5.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp5.png-wvc-sizes"
}, {
  code: "HP6",
  nameVi: "Nhiệm vụ",
  nameEn: "Mission Bot",
  url: "/RoboticsCourseHP6Page",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp6.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp6.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_course_hp6.png-wvc-sizes"
}];
function RelatedProgramsConsumer({
  lang
}: {
  lang: "vi" | "en";
}) {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-4">
        {[1, 2, 3].map(n => <div key={n} className="h-32 bg-muted/50 rounded-xl animate-pulse" />)}
      </div>;
  }
  if (error || !posts || posts.length === 0) {
    return null;
  }
  return <div className="mt-12 pt-8 border-t border-border">
      <h3 className="text-lg font-semibold tracking-tight text-foreground mb-4 font-serif">
        {contentData[lang].relatedProgramsTitle}
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {posts.slice(0, 3).map((post, i) => <Card key={post.id} data-index={i} className="border border-border/80 shadow-xs hover:border-primary/40 transition-colors">
            <CardHeader className="pb-2">
              <Badge variant="outline" className="w-fit mb-1 text-xs">
                {post.customFields?.level || "Robotics"}
              </Badge>
              <CardTitle className="text-base font-semibold line-clamp-1">
                {post.customFields?.program_name || post.title}
              </CardTitle>
            </CardHeader>
            <CardContent className="pt-0 text-sm">
              <p className="text-muted-foreground text-xs line-clamp-2 mb-3">
                {post.customFields?.tagline || post.excerpt || "Chương trình đào tạo công nghệ robotics chuẩn quốc tế cho trẻ em."}
              </p>
              {post.link && <Button asChild variant="link" size="sm" className="px-0 h-auto font-medium text-primary">
                  <Link to={post.link}>
                    {contentData[lang].viewProgramDetails} →
                  </Link>
                </Button>}
            </CardContent>
          </Card>)}
      </div>
    </div>;
}
export default function CourseDetail() {
  const [lang, setLang] = useState<"vi" | "en">("vi");
  const t = contentData[lang];
  return <section id="coursehp5detail" data-nav="light" className="bg-background text-foreground py-12 md:py-16 transition-colors">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Navigation & Controls Bar: (1) 4-level Breadcrumb */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pb-6 mb-8 border-b border-border">
          <Breadcrumb>
            <BreadcrumbList>
              {/* Level 1: Trang chủ / Home */}
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/" className="text-xs font-semibold uppercase text-muted-foreground hover:text-primary transition-colors">
                    {t.homeCrumb}
                  </Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />

              {/* Level 2: Lộ trình Robotics / Robotics Pathway */}
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/RoboticsLearningPathwayPage" className="text-xs font-semibold uppercase text-muted-foreground hover:text-primary transition-colors">
                    {t.pathwayCrumb}
                  </Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />

              {/* Level 3: Robotics 7+ tuổi / Robotics Ages 7+ */}
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="#" className="text-xs font-semibold uppercase text-muted-foreground hover:text-primary transition-colors">
                    {t.trackCrumb}
                  </Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />

              {/* Level 4: HP5 – Thành phố xe tự lái (Current) */}
              <BreadcrumbItem>
                <BreadcrumbPage className="text-xs font-bold uppercase text-primary">
                  {t.courseCrumb}
                </BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>

          {/* Language Switcher */}
          <div className="flex items-center gap-1 bg-muted p-1 rounded-lg self-start sm:self-auto border border-border">
            <Button type="button" variant={lang === "vi" ? "default" : "ghost"} size="sm" onClick={() => setLang("vi")} className={`h-7 px-2.5 text-xs font-semibold rounded-md ${lang === "vi" ? "shadow-xs" : "text-muted-foreground hover:text-foreground"}`}>
              Tiếng Việt
            </Button>
            <Button type="button" variant={lang === "en" ? "default" : "ghost"} size="sm" onClick={() => setLang("en")} className={`h-7 px-2.5 text-xs font-semibold rounded-md ${lang === "en" ? "shadow-xs" : "text-muted-foreground hover:text-foreground"}`}>
              English
            </Button>
          </div>
        </div>

        {/* (2) Hero & Overview */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start mb-14">
          <div className="lg:col-span-8 flex flex-col gap-5">
            <div className="flex flex-wrap items-center gap-2.5">
              <Badge className="bg-primary text-primary-foreground font-semibold px-3 py-1 text-xs">
                {t.courseLabel}
              </Badge>
              <Badge variant="secondary" className="bg-secondary/20 text-secondary-foreground border-secondary/30 font-medium px-3 py-1 text-xs">
                {t.ageBadge}
              </Badge>
              <Badge variant="outline" className="border-border text-muted-foreground font-medium px-3 py-1 text-xs">
                {t.prerequisiteVal}
              </Badge>
            </div>

            <div>
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-foreground font-serif">
                {t.title}
              </h1>
            </div>

            {/* Hero Visual Card: Wheeled robot with 5-channel grayscale sensors following a track */}
            <div className="relative rounded-2xl overflow-hidden border border-slate-800 bg-slate-950 text-slate-100 shadow-md group">
              <div className="relative aspect-[16/9] w-full overflow-hidden bg-slate-900">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/hp5_line_following_robot.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/hp5_line_following_robot.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/hp5_line_following_robot.png-wvc-sizes" alt="Autonomous wheeled robot with 5-channel optical grayscale line sensors navigating a precision track" loading="lazy" className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/30 to-transparent" />
                <div className="absolute top-3 left-3 flex flex-wrap items-center gap-2">
                  <Badge className="bg-slate-900/90 text-slate-100 border border-slate-700 font-mono text-[11px] uppercase tracking-wider backdrop-blur-md">
                    Lab Blueprint Spec
                  </Badge>
                  <Badge className="bg-slate-900/90 text-emerald-400 border border-emerald-500/40 font-mono text-[11px] backdrop-blur-md flex items-center gap-1.5">
                    <span className="size-1.5 rounded-full bg-emerald-400 animate-pulse" />
                    5-Ch Grayscale Active
                  </Badge>
                </div>
                <div className="absolute bottom-3 left-3 right-3 flex items-end justify-between gap-4">
                  <div className="bg-slate-950/85 backdrop-blur-md p-3 rounded-xl border border-slate-800 text-xs text-slate-200 font-mono w-full sm:w-auto">
                    <p className="font-semibold text-white">WhalesBot AI Module 1S Chassis</p>
                    <p className="text-slate-400 text-[11px] mt-0.5">Real-time optical reflectance feedback loop & autonomous routing</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Quote Block */}
            <div className="relative p-5 sm:p-6 rounded-2xl bg-muted/60 border border-border/80 flex items-start gap-3.5">
              <Quote className="size-6 text-primary shrink-0 opacity-80 mt-0.5" />
              <div>
                <p className="text-base sm:text-lg italic font-medium text-foreground/90 leading-relaxed">
                  &ldquo;{t.conceptQuote}&rdquo;
                </p>
                <span className="text-xs text-muted-foreground mt-1.5 block uppercase tracking-wider font-semibold">
                  ROBOTO Academy • Core Thesis
                </span>
              </div>
            </div>

            <p className="text-muted-foreground text-base leading-relaxed">
              {t.focusDesc}
            </p>

            {/* Hero CTAs: Primary 'ĐĂNG KÝ TƯ VẤN' + Secondary 'XEM TOÀN BỘ LỘ TRÌNH' */}
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3.5 pt-2">
              <Button asChild size="lg" className="bg-accent hover:bg-accent/90 text-accent-foreground font-semibold px-7 py-3.5 rounded-lg shadow-sm">
                <Link to="/FreeTrialContactPage">
                  {t.ctaConsult}
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground font-semibold px-6 py-3.25 rounded-lg transition-colors">
                <Link to="/RoboticsLearningPathwayPage">
                  {t.ctaPathway}
                </Link>
              </Button>
            </div>
          </div>

          {/* Quick Specifications Card */}
          <div className="lg:col-span-4 flex flex-col gap-4">
            <Card className="border border-border shadow-sm bg-card">
              <CardHeader className="pb-3 border-b border-border/60">
                <CardTitle className="text-base font-semibold flex items-center gap-2">
                  <Layers className="size-4 text-primary" />
                  {lang === "vi" ? "Thông số khóa học" : "Course Specifications"}
                </CardTitle>
              </CardHeader>
              <CardContent className="pt-4 divide-y divide-border/60 text-sm">
                <div className="py-2.5 flex items-start justify-between gap-2">
                  <div className="flex items-center gap-2 text-muted-foreground">
                    <Cpu className="size-4 shrink-0 text-primary" />
                    <span>{t.platformLabel}</span>
                  </div>
                  <span className="font-semibold text-right text-foreground">
                    WhalesBot AI Module 1S
                  </span>
                </div>

                <div className="py-2.5 flex items-start justify-between gap-2">
                  <div className="flex items-center gap-2 text-muted-foreground">
                    <Clock className="size-4 shrink-0 text-accent" />
                    <span>{t.durationLabel}</span>
                  </div>
                  <span className="font-semibold text-right text-foreground">
                    {lang === "vi" ? "12 buổi × 90 phút" : "12 sessions × 90 mins"}
                  </span>
                </div>

                <div className="py-2.5 flex items-start justify-between gap-2">
                  <div className="flex items-center gap-2 text-muted-foreground">
                    <Users className="size-4 shrink-0 text-secondary" />
                    <span>{t.groupSizeLabel}</span>
                  </div>
                  <span className="font-semibold text-right text-foreground">
                    {lang === "vi" ? "2–3 học sinh / kit" : "2–3 students / kit"}
                  </span>
                </div>

                <div className="py-2.5 flex items-start justify-between gap-2">
                  <div className="flex items-center gap-2 text-muted-foreground">
                    <CheckCircle2 className="size-4 shrink-0 text-primary" />
                    <span>{t.prerequisiteLabel}</span>
                  </div>
                  <span className="font-semibold text-right text-primary">
                    {t.prerequisiteVal}
                  </span>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* (3) 'Who is this course for?' section */}
        <div className="mb-14 p-6 sm:p-8 rounded-2xl bg-card border border-border shadow-xs">
          <div className="flex items-center gap-3 mb-4">
            <div className="size-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center shrink-0">
              <Target className="size-5" />
            </div>
            <div>
              <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-foreground font-serif">
                {t.whoIsThisForTitle}
              </h2>
              <p className="text-xs sm:text-sm text-muted-foreground">
                {t.whoIsThisForSubtitle}
              </p>
            </div>
          </div>

          <div className="p-4 sm:p-5 rounded-xl bg-muted/40 border border-border flex items-start gap-3.5">
            <CheckCircle2 className="size-5 text-secondary shrink-0 mt-0.5" />
            <div>
              <p className="text-base sm:text-lg font-medium text-foreground leading-relaxed">
                {t.whoIsThisForCopy}
              </p>
              <div className="mt-3 flex flex-wrap gap-2">
                <Badge variant="outline" className="text-xs bg-card">
                  {lang === "vi" ? "Yêu cầu: Hoàn thành HP4" : "Prerequisite: Completed HP4"}
                </Badge>
                <Badge variant="outline" className="text-xs bg-card">
                  {lang === "vi" ? "Robot bám vạch tự hành" : "Autonomous line-following"}
                </Badge>
                <Badge variant="outline" className="text-xs bg-card">
                  {lang === "vi" ? "Lập kế hoạch đường đi" : "Route-planning algorithms"}
                </Badge>
              </div>
            </div>
          </div>
        </div>

        {/* Focus Skills Grid (Preserving exact existing skills list) */}
        <div className="mb-14">
          <div className="flex items-center gap-2 mb-6">
            <Compass className="size-5 text-primary" />
            <h2 className="text-2xl font-bold tracking-tight text-foreground font-serif">
              {t.focusTitle}
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3.5">
            {focusSkills.map((item, index) => <div key={index} data-index={index} className="p-4 rounded-xl border border-border bg-card/60 hover:bg-card hover:border-primary/40 hover:shadow-xs transition-all flex items-start gap-3">
                <div className="size-8 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0 font-semibold text-xs mt-0.5">
                  {(index + 1).toString().padStart(2, "0")}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2 mb-1">
                    <span className="text-xs uppercase tracking-wider text-muted-foreground font-semibold">
                      {item.tag}
                    </span>
                    <Sparkles className="size-3 text-accent shrink-0" />
                  </div>
                  <p className="text-sm font-semibold text-foreground leading-snug">
                    {lang === "vi" ? item.vi : item.en}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        {/* Mid-Page Visual: Track and Intersection Diagram for Line-Following Navigation */}
        <div className="mb-14 p-6 sm:p-8 rounded-2xl bg-slate-950 text-slate-100 border border-slate-800 shadow-md relative overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="lg:w-1/2 space-y-4">
              <div className="inline-flex items-center gap-2 px-2.5 py-1 rounded-md bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 text-xs font-mono font-semibold uppercase tracking-wider">
                <Workflow className="size-3.5" />
                Navigation Blueprint
              </div>
              <h2 className="text-2xl sm:text-3xl font-bold font-serif text-white tracking-tight">
                {lang === "vi" ? "Sơ đồ giải thuật bám vạch & Điều hướng ngã tư" : "Line-Following & Intersection Navigation Diagram"}
              </h2>
              <p className="text-sm text-slate-300 leading-relaxed">
                {lang === "vi" ? "Mô phỏng sa bàn đô thị tiêu chuẩn HP5 với các điểm giao cắt, vạch tuần tra và node định tuyến. Cụm 5 cảm biến quang sai liên tục tính toán độ lệch quỹ đạo (Deviation Error) để điều chỉnh hai động cơ chính xác theo millisecond." : "Standard HP5 urban grid map simulation showing intersection nodes, patrol tracks, and routing markers. The 5-channel optical sensor array continuously computes trajectory deviation error to execute millisecond-level motor feedback adjustments."}
              </p>
              <div className="grid grid-cols-2 gap-3 pt-2 text-xs font-mono">
                <div className="p-3 rounded-lg bg-slate-900 border border-slate-800">
                  <span className="text-emerald-400 block font-bold mb-1">90° Cross Junctions</span>
                  <span className="text-slate-400">Automatic intersection counting & node decisioning</span>
                </div>
                <div className="p-3 rounded-lg bg-slate-900 border border-slate-800">
                  <span className="text-amber-400 block font-bold mb-1">Intuitive P Control</span>
                  <span className="text-slate-400">Proportional feedback line-centering routine</span>
                </div>
              </div>
            </div>

            <div className="lg:w-1/2 w-full">
              <div className="relative rounded-xl overflow-hidden border border-slate-800 bg-slate-900 group">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/line_following_track_diagram.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/line_following_track_diagram.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/line_following_track_diagram.png-wvc-sizes" alt="Technical track and intersection diagram for line-following robot navigation and route planning" loading="lazy" className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-102" />
                <div className="absolute inset-x-0 bottom-0 p-3 bg-slate-950/90 backdrop-blur-md border-t border-slate-800 flex items-center justify-between text-[11px] font-mono text-slate-300">
                  <span className="flex items-center gap-1.5 text-emerald-400">
                    <span className="size-2 rounded-full bg-emerald-400 animate-ping" />
                    Grid Topological Map v5.0
                  </span>
                  <span className="text-slate-400">ROBOTO Lab Technical Spec</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* (4) 12-session timeline grouped into 6 stages (Using HP5 official topics) */}
        <div className="mb-14 p-6 sm:p-8 rounded-2xl bg-card border border-border shadow-xs">
          <div className="flex items-center gap-3 mb-2">
            <div className="size-10 rounded-xl bg-secondary/15 text-secondary flex items-center justify-center shrink-0">
              <Clock className="size-5" />
            </div>
            <div>
              <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-foreground font-serif">
                {t.timelineTitle}
              </h2>
              <p className="text-xs sm:text-sm text-muted-foreground">
                {t.timelineSubtitle}
              </p>
            </div>
          </div>

          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
            {timelineStages.map((stg, idx) => <div key={stg.stage} data-index={idx} className="p-4 sm:p-5 rounded-xl border border-border bg-muted/30 hover:border-primary/30 transition-colors flex flex-col justify-between">
                <div>
                  <div className="flex items-center justify-between gap-2 mb-2">
                    <Badge variant="outline" className="text-xs font-semibold border-secondary/40 text-secondary-foreground bg-secondary/10">
                      {lang === "vi" ? stg.sessionsVi : stg.sessionsEn}
                    </Badge>
                    <span className="text-xs font-mono font-bold text-muted-foreground">
                      {lang === "vi" ? `GIAI ĐOẠN ${stg.stage}` : `STAGE ${stg.stage}`}
                    </span>
                  </div>
                  <h3 className="text-base font-bold text-foreground font-serif mb-1.5">
                    {lang === "vi" ? stg.titleVi : stg.titleEn}
                  </h3>
                  <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
                    {lang === "vi" ? stg.topicsVi : stg.topicsEn}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        {/* (5) 4-step learning method section matching D1-D4 pattern */}
        <div className="mb-14">
          <div className="flex items-center gap-2 mb-2">
            <Flame className="size-5 text-accent" />
            <h2 className="text-2xl font-bold tracking-tight text-foreground font-serif">
              {t.methodologyTitle}
            </h2>
          </div>
          <p className="text-xs sm:text-sm text-muted-foreground mb-6">
            {t.methodologySubtitle}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {methodologySteps.map((step, idx) => {
            const StepIcon = step.icon;
            return <div key={step.step} data-index={idx} className="p-5 rounded-xl border border-border bg-card shadow-xs relative flex flex-col justify-between">
                  <div>
                    <div className="flex items-center justify-between mb-4">
                      <div className="size-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center">
                        <StepIcon className="size-5" />
                      </div>
                      <span className="text-xs font-mono font-bold text-muted-foreground">
                        STEP 0{step.step}
                      </span>
                    </div>
                    <h3 className="text-base font-bold text-foreground mb-1.5 font-serif">
                      {lang === "vi" ? step.titleVi : step.titleEn}
                    </h3>
                    <p className="text-xs text-muted-foreground leading-relaxed">
                      {lang === "vi" ? step.descVi : step.descEn}
                    </p>
                  </div>
                </div>;
          })}
          </div>
        </div>

        {/* (6) Equipment card & (7) Small-group learning model section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-14">
          {/* Equipment Card */}
          <Card className="border border-border bg-card shadow-xs">
            <CardHeader className="pb-3 border-b border-border/60">
              <div className="flex items-center gap-2">
                <div className="size-8 rounded-lg bg-secondary/15 text-secondary flex items-center justify-center shrink-0">
                  <Cpu className="size-4" />
                </div>
                <div>
                  <CardTitle className="text-lg font-bold font-serif">
                    {t.equipmentCardTitle}
                  </CardTitle>
                  <p className="text-xs text-muted-foreground">
                    {t.equipmentCardSubtitle}
                  </p>
                </div>
              </div>
            </CardHeader>
            <CardContent className="pt-5 space-y-4 text-sm">
              <div className="rounded-xl overflow-hidden border border-border bg-muted/20">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/whalesbot_robotics_kit.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/whalesbot_robotics_kit.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/whalesbot_robotics_kit.png-wvc-sizes" alt="WhalesBot AI Module 1S robotics kit used in ROBOTO's HP1–HP6 engineering track" loading="lazy" className="w-full h-44 object-cover object-center" />
              </div>

              <div className="p-3.5 rounded-lg bg-muted/40 border border-border flex items-center justify-between">
                <span className="font-semibold text-foreground text-sm">
                  {t.equipmentModel}
                </span>
                <Badge variant="outline" className="border-secondary text-secondary-foreground font-semibold">
                  Standard Kit
                </Badge>
              </div>

              <div className="p-3.5 rounded-lg bg-muted/40 border border-border space-y-1">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2 text-muted-foreground">
                    <Coins className="size-4 text-accent" />
                    <span>{t.equipmentCostLabel}</span>
                  </div>
                  <span className="font-bold text-foreground">
                    {t.equipmentCostValue}
                  </span>
                </div>
                <p className="text-[11px] text-muted-foreground italic pt-1">
                  {t.equipmentCostNote}
                </p>
              </div>

              <div className="p-3.5 rounded-lg bg-muted/40 border border-border flex items-center justify-between">
                <div className="flex items-center gap-2 text-muted-foreground">
                  <Laptop className="size-4 text-primary" />
                  <span>{t.computerRequirementLabel}</span>
                </div>
                <span className="font-semibold text-primary">
                  {t.computerRequirementVal}
                </span>
              </div>
            </CardContent>
          </Card>

          {/* Small-Group Model Card */}
          <Card className="border border-border bg-card shadow-xs">
            <CardHeader className="pb-3 border-b border-border/60">
              <div className="flex items-center gap-2">
                <div className="size-8 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0">
                  <Users className="size-4" />
                </div>
                <div>
                  <CardTitle className="text-lg font-bold font-serif">
                    {t.groupModelTitle}
                  </CardTitle>
                  <p className="text-xs text-muted-foreground">
                    {t.groupModelSubtitle}
                  </p>
                </div>
              </div>
            </CardHeader>
            <CardContent className="pt-5 space-y-3.5 text-sm">
              <div className="p-3.5 rounded-lg bg-secondary/10 border border-secondary/30">
                <div className="flex items-center gap-2 mb-1">
                  <CheckCircle2 className="size-4 text-secondary shrink-0" />
                  <span className="font-bold text-foreground">
                    {t.groupIdeal}
                  </span>
                </div>
                <p className="text-xs text-muted-foreground leading-relaxed pl-6">
                  {t.groupIdealDesc}
                </p>
              </div>

              <div className="p-3.5 rounded-lg bg-muted/40 border border-border">
                <div className="flex items-center gap-2 mb-1">
                  <Workflow className="size-4 text-accent shrink-0" />
                  <span className="font-bold text-foreground">
                    {t.groupOptimized}
                  </span>
                </div>
                <p className="text-xs text-muted-foreground leading-relaxed pl-6">
                  {t.groupOptimizedDesc}
                </p>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* (8) Final project / capstone activity section */}
        <div className="mb-14 p-6 sm:p-8 rounded-2xl bg-card border-2 border-primary/20 shadow-xs">
          <div className="flex items-center gap-3 mb-3">
            <div className="size-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center shrink-0">
              <Trophy className="size-5" />
            </div>
            <div>
              <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-foreground font-serif">
                {t.capstoneTitle}
              </h2>
              <p className="text-xs sm:text-sm text-muted-foreground">
                {t.capstoneSubtitle}
              </p>
            </div>
          </div>

          <p className="text-sm sm:text-base text-foreground/90 leading-relaxed mt-4 p-4 rounded-xl bg-muted/40 border border-border">
            {t.capstoneDesc}
          </p>
        </div>

        {/* (9) 10-node pathway map with HP5 highlighted */}
        <div className="mb-14 p-6 sm:p-8 rounded-2xl bg-card border border-border shadow-xs">
          <div className="flex items-center gap-2.5 mb-2">
            <MapPin className="size-5 text-primary" />
            <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-foreground font-serif">
              {t.roadmapTitle}
            </h2>
          </div>
          <p className="text-xs sm:text-sm text-muted-foreground mb-6">
            {t.roadmapSubtitle}
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-5 lg:grid-cols-10 gap-2.5">
            {pathwayNodes.map((node, i) => <div key={node.code} data-index={i} className="flex flex-col">
                {node.isCurrent ? <div className="p-2.5 sm:p-3 rounded-xl border-2 border-primary bg-primary/10 text-center flex flex-col items-center justify-center shadow-xs h-full">
                    <div className="w-full aspect-square rounded-lg overflow-hidden border border-primary/30 mb-2 bg-background">
                      <img src={node.imgSrc} data-wvc-srcset={node.imgSrcset} data-wvc-sizes={node.imgSizes} alt={`${node.code} robotics course thumbnail`} loading="lazy" className="w-full h-full object-cover" />
                    </div>
                    <span className="text-sm font-extrabold text-primary block">
                      {node.code}
                    </span>
                    <span className="text-[10px] font-semibold text-foreground/80 line-clamp-1 mt-0.5">
                      {lang === "vi" ? node.nameVi : node.nameEn}
                    </span>
                    <Badge className="bg-primary text-primary-foreground text-[9px] px-1.5 py-0 mt-1">
                      {lang === "vi" ? "Hiện tại" : "Current"}
                    </Badge>
                  </div> : <Link to={node.url || "#"} className="p-2.5 sm:p-3 rounded-xl border border-border bg-muted/30 hover:bg-muted/70 hover:border-primary/40 text-center flex flex-col items-center justify-center transition-colors h-full group">
                    <div className="w-full aspect-square rounded-lg overflow-hidden border border-border/60 group-hover:border-primary/40 mb-2 bg-background">
                      <img src={node.imgSrc} data-wvc-srcset={node.imgSrcset} data-wvc-sizes={node.imgSizes} alt={`${node.code} robotics course thumbnail`} loading="lazy" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
                    </div>
                    <span className="text-sm font-bold text-foreground group-hover:text-primary transition-colors block">
                      {node.code}
                    </span>
                    <span className="text-[10px] text-muted-foreground group-hover:text-foreground line-clamp-1 mt-0.5">
                      {lang === "vi" ? node.nameVi : node.nameEn}
                    </span>
                  </Link>}
              </div>)}
          </div>
        </div>

        {/* (10) 'What's next' card: next course HP6 – Robot nhiệm vụ / Mission Robot */}
        <div className="mb-10 p-6 sm:p-8 rounded-2xl bg-muted/50 border-2 border-primary/20 shadow-xs flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div className="max-w-2xl">
            <div className="flex items-center gap-2 mb-2">
              <ShieldCheck className="size-5 text-secondary" />
              <span className="text-xs font-bold uppercase tracking-wider text-primary">
                {t.nextStepTitle}
              </span>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-foreground font-serif mb-2">
              {t.nextStepCourse}
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {t.nextStepDesc}
            </p>
          </div>

          <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-6 py-3 rounded-lg shadow-xs shrink-0 self-start md:self-auto">
            <Link to="/RoboticsCourseHP6Page" className="inline-flex items-center gap-2">
              <span>{t.nextStepCta}</span>
              <ArrowRight className="size-4" />
            </Link>
          </Button>
        </div>

        {/* Prev / Next Course Navigation Buttons */}
        <div className="pt-8 border-t border-border flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-4">
          <Button asChild variant="outline" size="lg" className="group justify-start border-border hover:border-primary/50 hover:bg-muted/50">
            <Link to="/RoboticsCourseHP4Page" className="inline-flex items-center gap-2">
              <ChevronLeft className="size-4 transition-transform group-hover:-translate-x-0.5" />
              <span>{t.prevCourse}</span>
            </Link>
          </Button>

          <Button asChild variant="default" size="lg" className="group justify-end bg-primary hover:bg-primary/90 text-primary-foreground shadow-xs">
            <Link to="/RoboticsCourseHP6Page" className="inline-flex items-center gap-2">
              <span>{t.nextCourse}</span>
              <ChevronRight className="size-4 transition-transform group-hover:translate-x-0.5" />
            </Link>
          </Button>
        </div>

        {/* Related Programs via WordPress PostsProvider */}
        <PostsProvider wp_query={{
        post_type: "program",
        per_page: 3,
        status: ["publish"]
      }}>
          <RelatedProgramsConsumer lang={lang} />
        </PostsProvider>
      </div>
    </section>;
}